import { UtenteDTO } from "./utenteDTO";
import { TipoElementoEnum } from "../enum/tipo-elemento-enum";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";

export class VisibilitaRequestDTO {

    utente: UtenteDTO;

    idElemento: string;

    tipoElemento: TipoElementoEnum;

    tipoVisibilita: TipoVisibilitaEnum;

}


